module.exports = __webpack_public_path__ + "static/img/m8.f6f1884.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-neo/mobile/m8.png
// module id = +4xK
// module chunks = 12